import React, { Component } from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as userActions from '../../../actions/users';
import DataTable from '../../../components/data-table/data-table';
import Button from '../../../components/button';
import LocalizedStrings from '../../../localization/strings';

class UsersContainer extends Component {

  componentWillMount() {
    this.fetch({});
  }

  constructor(props) {
    super(props);
    this.state = {
      page: 0
    };
  }

  fetch(params) {
    const fetchParams = {
      ...this.state,
      ...params
    };
    this.setState(fetchParams);
    this.props.actions.loadUsers(fetchParams.page, fetchParams.size);
  }

  removeUser(user) {
    if (confirm(LocalizedStrings.doYouWantToRemove)) {
      this.props.actions.deleteUser(user);
    }
  }

  render() {
    const { items, total, page, loading, total_pages } = this.props.users;

    var config = {
      cols: [
        {
          value: 'email',
          header: 'Email'
        }, {
          value: (item) => {
            return `${item.first_name} ${item.last_name}`;
          },
          header: 'First name, Last Name'
        }, {
          value: (item) => {
            return (
              <div className="btn-group">
                <Link className="btn" to={`/admin/users/${item.id}`}>{LocalizedStrings.edit}</Link>
                <a className="btn btn-red"
                   onClick={this.removeUser.bind(this, item)}>{LocalizedStrings.delete}</a>

              </div>

            );
          },


          header: 'Actions'
        }
      ]
    };
    return (
      <div>
        <h3>Users</h3>
        <Link to="/admin/users/new">
          <Button>New User</Button>
        </Link>
        <div className="panel">
          <div className="panel-body">
            <DataTable config={config} items={items} page={page} total={total} totalPages={total_pages}
                       loadAction={this.fetch.bind(this)} loading={loading} />

          </div>
        </div>
      </div>
    );
  }
}

export default connect(function(state) {
  return { users: state.admin.users.result };
}, function(dispatch) {
  return {
    actions: bindActionCreators({
      ...userActions
    }, dispatch)
  };
})(UsersContainer);



// WEBPACK FOOTER //
// ./src/js/containers/admin/users/users-container.js